<template>
    <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
        <a-select  :allowClear="allowClear" :style="selectStyle" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
            <template v-if="!$attrs.disabled">
              <a-icon slot="suffixIcon" type="caret-down" />
            </template>
          <template v-if="$attrs.disabled">
            <span slot="suffixIcon"></span>
          </template>
            <a-select-option v-for="(item,index) in list" :key="index"   :value="item.wordKey"><div><span>{{item.wordValue}}</span></div></a-select-option>
        </a-select>
        <a-icon  class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
    </div>
   <a-select v-else :allowClear="allowClear"  :filterOption="filterOption"  showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <template v-if="!$attrs.disabled">
       <a-icon slot="suffixIcon" type="caret-down" />
     </template>
     <template v-if="$attrs.disabled">
       <span slot="suffixIcon"></span>
     </template>
     <a-select-option v-for="(item,index) in list" :key="index"   :value="item.wordKey"><div><span>{{item.wordValue}}</span></div></a-select-option>
   </a-select>
</template>

<script>
/**
 * 数据字典选择,传入字典路径
 */
  import {getDatadictChildsByPath} from "@/api/sys/datadict";
  export default {
    name: 'ptDictSelect',
    props:{
      placeholder:{
        type:String,
        default:"请选择",
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      dictPath:{
        type:String,
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },

    },
    data() {
      return {
        input:this.value,
        list:[],
        open:false,
      }
    },

    watch:{
      value (val) {
        this.input = val
        console.log("this.input",val)
      },
      input(val){
        this.$emit('input',val)
      },
    },
    mounted(){
      this.initData()
    },
    methods:{
      dropdownVisibleChange(open){
        this.open = open
      },
      filterOption(input, option){
        return (
          option.componentOptions.children[0].children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      initData() {
        getDatadictChildsByPath(this.dictPath).then(res => {
          if(res.code == 1) {
            this.list = res.data;
            console.log("====", this.list)
          }
        })
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value);
      }
    }
  }
</script>

<style scoped lang="less">
    .pt-select-div{
        position: relative;
        width: 100%;
        display: inline;
        /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
            margin-left: 0px;
        }
        .multiple-icon{
            position: absolute;
            color: rgba(0, 0, 0, 0.25);
            right: 11px;
            top: 10px;
            font-size: 12px;
        }
        .openClass{
            transform: rotate(180deg);
        }

    }

    .option_div{
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
</style>